import { Box, Paper, Typography } from "@mui/material";
import FormActionButton from "../buttons/formActionButton.component";
import { Add } from "@mui/icons-material";

const EmptyState = ({ text, buttonLabel, href, navigate }) => {
  return (
    <Paper
      sx={{
        paddingY: 2,
        paddingX: 4,
        width: "100%",
        overflow: "auto",
        height: "100%",
      }}
      elevation={0}
    >
      <Box
        display="flex"
        width="100%"
        height="100%"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        gap={1}
      >
        <Typography fontSize="14px">{text}</Typography>
        <FormActionButton
          startIcon={<Add />}
          label={buttonLabel}
          onClick={() => navigate(href)}
        />
      </Box>
    </Paper>
  );
};

export default EmptyState;
